'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseDragDrop = require('@bibliocommons/base-drag-drop');

var _sharedJacketCover = require('@bibliocommons/shared-jacket-cover');

var _sharedJacketCover2 = _interopRequireDefault(_sharedJacketCover);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

require('@bibliocommons/assets/stylesheets/animations.scss');

var _utilsList = require('@bibliocommons/utils-list');

var _itemIndex = require('../../item-index');

var _itemIndex2 = _interopRequireDefault(_itemIndex);

var _moveButton = require('../../move-button');

var _moveButton2 = _interopRequireDefault(_moveButton);

var _itemScreenReaderDescription = require('../../item-screen-reader-description');

var _itemScreenReaderDescription2 = _interopRequireDefault(_itemScreenReaderDescription);

var _itemAnnotationInput = require('../../item-annotation-input');

var _itemAnnotationInput2 = _interopRequireDefault(_itemAnnotationInput);

var _bibItemInfo = require('../../bib-item-info');

var _bibItemInfo2 = _interopRequireDefault(_bibItemInfo);

var _webItemInfo = require('../../web-item-info');

var _webItemInfo2 = _interopRequireDefault(_webItemInfo);

var _deletePrompt = require('../../delete-prompt');

var _deletePrompt2 = _interopRequireDefault(_deletePrompt);

require('../styles/ListItem.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = exports.ListItem = function (_BcReactComponent) {
  _inherits(ListItem, _BcReactComponent);

  function ListItem(props) {
    _classCallCheck(this, ListItem);

    var _this = _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

    _this.bindAll('handleAnnotationChange', 'handleDeleteItem', 'getHoverDirection', 'renderDeletePrompt', 'renderInfo', 'renderItemIndex', 'handleOpenDeletePrompt', 'handleCloseDeletePrompt', 'renderOpenDeletePromptButton', 'handleTitleChange');

    _this.state = {
      showDeletePrompt: false
    };
    return _this;
  }

  _createClass(ListItem, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // Focus on delete button if delete prompt canceled
      if (prevState.showDeletePrompt && !this.state.showDeletePrompt) {
        this.props.restoreFocus(this._deleteButton);
      }

      // Focus inside delete prompt if it just opened
      if (!prevState.showDeletePrompt && this.state.showDeletePrompt) {
        this.props.captureFocus(this._deletePrompt, false);
      }
    }
  }, {
    key: 'handleOpenDeletePrompt',
    value: function handleOpenDeletePrompt() {
      this.setState({ showDeletePrompt: true });
    }
  }, {
    key: 'handleCloseDeletePrompt',
    value: function handleCloseDeletePrompt() {
      this.setState({ showDeletePrompt: false });
    }
  }, {
    key: 'handleDeleteItem',
    value: function handleDeleteItem() {
      this.props.handleRemoveItem(this.props.item);
    }
  }, {
    key: 'handleAnnotationChange',
    value: function handleAnnotationChange(value) {
      this.props.handleItemPropertyChange(this.props.item, _immutable2.default.Map({ annotation: value }));
    }
  }, {
    key: 'getHoverDirection',
    value: function getHoverDirection() {
      return this.props.itemIndex > this.props.hoverItem.itemIndex ? 'above' : 'below';
    }
  }, {
    key: 'handleTitleChange',
    value: function handleTitleChange(value) {
      this.props.handleItemPropertyChange(this.props.item, _immutable2.default.Map({
        urlListItem: _immutable2.default.Map({
          url: _immutable2.default.Map({
            title: value
          })
        })
      }));
    }
  }, {
    key: 'renderInfo',
    value: function renderInfo() {
      var key = this.props.item ? (0, _utilsList.generateKeyForListItem)(this.props.item) : 'new';
      var labelId = key + '-web-item-title-label';
      var inputId = key + '-web-item-title-input';

      if (ListItem.isUrlItem(this.props.item)) {
        return _react2.default.createElement(_webItemInfo2.default, {
          id: inputId,
          labelledById: labelId,
          item: this.props.item,
          handleChange: this.handleTitleChange });
      }
      return _react2.default.createElement(_bibItemInfo2.default, { item: this.props.item });
    }
  }, {
    key: 'renderOpenDeletePromptButton',
    value: function renderOpenDeletePromptButton() {
      var _this2 = this;

      if (!this.state.showDeletePrompt) {
        return _react2.default.createElement(
          _baseButtons.DefaultButton,
          {
            className: 'btn-ugc remove-button',
            'data-test-id': 'remove-button',
            ref: function ref(el) {
              return _this2._deleteButton = el;
            },
            flat: true,
            handleClick: this.handleOpenDeletePrompt },
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'ada_label_remove_item_from_list',
              values: { title: _react2.default.createElement(_itemScreenReaderDescription2.default, { item: this.props.item }) } })
          ),
          _react2.default.createElement(_baseIcons.Remove, { color: '' })
        );
      }

      return null;
    }
  }, {
    key: 'renderDeletePrompt',
    value: function renderDeletePrompt() {
      var _this3 = this;

      if (this.state.showDeletePrompt) {
        return _react2.default.createElement(_deletePrompt2.default, {
          key: 1,
          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_delete_prompt' }),
          ref: function ref(el) {
            return _this3._deletePrompt = el;
          },
          handleDelete: this.handleDeleteItem,
          handleCancel: this.handleCloseDeletePrompt });
      }

      return null;
    }
  }, {
    key: 'renderItemIndex',
    value: function renderItemIndex() {
      var _props = this.props,
          showIndex = _props.showIndex,
          itemIndex = _props.itemIndex;

      if (showIndex) {
        return _react2.default.createElement(_itemIndex2.default, { index: itemIndex });
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isDragging = _props2.isDragging,
          isOver = _props2.isOver,
          hoverItem = _props2.hoverItem,
          item = _props2.item,
          isFirstItem = _props2.isFirstItem,
          isLastItem = _props2.isLastItem;

      var draggingClass = isDragging ? 'dragging' : '';
      var hoveringClass = isOver && hoverItem.item !== item ? 'hovering-' + this.getHoverDirection() : '';
      var outlineClass = this.state.showDeletePrompt ? 'outline-item' : '';

      return _react2.default.createElement(
        'div',
        { className: 'row cp-user-list-item ' + draggingClass + ' ' + hoveringClass },
        _react2.default.createElement('div', { className: 'above insert-placeholder' }),
        _react2.default.createElement(
          'form',
          { className: 'item-content ' + outlineClass, action: '' },
          this.renderItemIndex(),
          _react2.default.createElement(
            'div',
            { className: 'flex-wrapper' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_sharedJacketCover2.default, {
                alt: '',
                format: ListItem.getFormat(item),
                src: ListItem.getJacketCoverSrc(item),
                testId: 'list-item-jacket-cover-' + ListItem.getTitle(item),
                size: 'medium' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'item-details' },
              this.renderInfo(),
              _react2.default.createElement(
                'span',
                { className: 'hidden-xs' },
                _react2.default.createElement(_itemAnnotationInput2.default, {
                  item: item,
                  value: item.get('annotation'),
                  allowFreeText: this.props.allowFreeText,
                  handleChange: this.handleAnnotationChange })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'visible-xs' },
            _react2.default.createElement(_itemAnnotationInput2.default, {
              item: item,
              value: item.get('annotation'),
              allowFreeText: this.props.allowFreeText,
              handleChange: this.handleAnnotationChange })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_moveButton2.default, {
              className: 'move-up',
              direction: 'up',
              disabled: isFirstItem,
              item: this.props.item,
              handleMove: this.props.handleItemMovedUp }),
            _react2.default.createElement(_moveButton2.default, {
              className: 'move-down',
              direction: 'down',
              disabled: isLastItem,
              item: this.props.item,
              handleMove: this.props.handleItemMovedDown }),
            this.renderOpenDeletePromptButton()
          ),
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            { transitionName: 'fade', transitionEnterTimeout: 250, transitionLeaveTimeout: 250 },
            this.renderDeletePrompt()
          )
        ),
        _react2.default.createElement('div', { className: 'below insert-placeholder' })
      );
    }
  }], [{
    key: 'isUrlItem',
    value: function isUrlItem(item) {
      return item.get('type') && item.get('type') === 'url';
    }
  }, {
    key: 'getFormat',
    value: function getFormat(item) {
      if (!ListItem.isUrlItem(item)) {
        return item.getIn(['bibListItem', 'format']);
      }
      return false;
    }
  }, {
    key: 'getTitle',
    value: function getTitle(item) {
      if (ListItem.isUrlItem(item)) {
        return item.getIn(['urlListItem', 'url', 'title']);
      }
      return item.getIn(['bibListItem', 'title']);
    }
  }, {
    key: 'getJacketCoverSrc',
    value: function getJacketCoverSrc(item) {
      var jacket = item.get('jacketCover');
      return _immutable2.default.Map({
        small: jacket.get('smallCover'),
        medium: jacket.get('mediumCover'),
        large: jacket.get('largeCover'),
        local_url: jacket.get('localUrl'),
        type: jacket.get('type')
      });
    }
  }]);

  return ListItem;
}(_baseBcReactComponent2.default);

ListItem.propTypes = {
  item: _bcPropTypes.listItemShape,
  itemIndex: _react.PropTypes.number.isRequired,
  handleRemoveItem: _react.PropTypes.func.isRequired,
  handleUndoRemoveItem: _react.PropTypes.func.isRequired,
  handleItemPropertyChange: _react.PropTypes.func.isRequired,
  handleItemDragged: _react.PropTypes.func.isRequired,
  handleItemMovedUp: _react.PropTypes.func.isRequired,
  handleItemMovedDown: _react.PropTypes.func.isRequired,
  allowFreeText: _react.PropTypes.bool.isRequired,
  showIndex: _react.PropTypes.bool.isRequired,
  isFirstItem: _react.PropTypes.bool,
  isLastItem: _react.PropTypes.bool,

  // Injected by DragDropSourceWrapper
  isDragging: _react.PropTypes.bool.isRequired,

  // Injected by DragDropTargetWrapper
  isOver: _react.PropTypes.bool.isRequired,
  hoverItem: _react.PropTypes.shape({
    item: _bcPropTypes.listItemShape
  }),

  // Injected by manageFocus
  captureFocus: _react.PropTypes.func.isRequired,
  restoreFocus: _react.PropTypes.func.isRequired
};

exports.default = (0, _baseDragDrop.dragDropTargetWrapper)((0, _baseDragDrop.dragDropSourceWrapper)((0, _baseAccessibilityManageFocus2.default)(ListItem), 'ListItem', 'handleItemDragged'), 'ListItem');


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-item/components/ListItem.component.js
// module id = 1309
// module chunks = 0